import workspaceQuery from '../../queries/nominal/NominalJournalWorkspaceQuery.graphql';
import instanceQuery from '../../queries/nominal/NominalJournalQuery.graphql';
import defaultQuery from '../../queries/nominal/NominalJournalDefault.graphql';
import mutationQuery from '../../mutations/nominal/NominalJournalMutation.graphql';
import temporaryMutationQuery from '../../mutations/nominal/SaveNominalJournalTempMutation.graphql';
import fragment from '../../fragments/nominal/NominalJournalFragment.graphql';

import { formActionsForPermissions } from '../../../actions/nominal/NominalJournalAction';
import { EntityType } from '../../../@types/entityTypes';
import { workspaceActionsForPermissions } from '../../../actions/nominal/NominalJournalWorkspaceAction';

const NominalJournal: EntityType = {
  type: 'NominalJournal',
  title: 'Nominal Journals',
  formUrl: '/Nominal/Journal/Details/',
  formTitle: 'Nominal Journals',
  workspaceUrl: '/Nominal/Journal/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'NOMINAL_JOURNAL',
  actions: formActionsForPermissions,
  workspaceActions: workspaceActionsForPermissions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'PENDING', 'REVERSED'],
    },
  ],
};

export default NominalJournal;
